/**
 * How a requested item reads on screen: "Group: Item" when it was asked
 * under a group (a "yes" question is named after its group, so just the
 * name), with the detail after a dash.
 */
export const itemLabel = (item) =>
  item?.group && item.group !== item.name ? `${item.group}: ${item.name}` : item?.name || '';

export const itemLine = (item) =>
  item?.detail ? `${itemLabel(item)} — ${item.detail}` : itemLabel(item);

/** "Službeni mejl: NE · Već ima računar: DA" for a request's yes / no answers. */
export const answersLine = (answers, tn) =>
  (answers || [])
    .map((answer) => `${answer.group}: ${tn(answer.value === 'yes' ? 'answerYes' : 'answerNo')}`)
    .join(' · ');

const lowerName = (value) => String(value || '').trim().toLowerCase();

/**
 * What was already asked for this employee and not given back: name → the
 * date of the latest request. Rejected requests do not count. Requests come
 * newest first. A yes / no question counts under its own name.
 */
export const alreadyRequested = (requests = []) => {
  const seen = new Map();
  const add = (name, date) => {
    const key = lowerName(name);
    if (key && !seen.has(key)) seen.set(key, date);
  };
  requests
    .filter((request) => request.approval?.status !== 'rejected')
    .forEach((request) => {
      const lines = [...(request.items || []), ...(request.extras || [])];
      const givenBack = new Set(
        lines
          .filter((line) => line.fromAnswer && line.state === 'returned')
          .map((line) => lowerName(line.group))
      );
      lines
        .filter((line) => line.state !== 'returned')
        .forEach((line) => add(line.fromAnswer ? line.group : line.name, request.requestedAt));
      (request.answers || [])
        .filter((answer) => answer.value === 'yes' && !givenBack.has(lowerName(answer.group)))
        .forEach((answer) => add(answer.group, request.requestedAt));
    });
  return seen;
};

/** Of `names` about to be sent, those already asked for: [{ name, date }]. */
export const repeatedLines = (names = [], requests = []) => {
  const seen = alreadyRequested(requests);
  return names
    .filter((name) => seen.has(lowerName(name)))
    .map((name) => ({ name, date: seen.get(lowerName(name)) }));
};
